export default "__VITE_ASSET__BDGhozvz__"